<template>
  <div class="pc_obj">
    <!-- 背景 -->
    <div>
      <div class="bgo">
        <img src="@/assets/bgs.svg" />
      </div>
      <div class="titleo">
        <img src="@/assets/logo1.svg" />
      </div>
    </div>

    <div class="maino">
      <!-- 顶部导航 -->
      <div class="topbar" v-if="breadcrumbData.length > 0">
        <Breadcrumb class="breadcrumb" :breadcrumbData="breadcrumbData" />
        <div class="goBack" @click="returnHome()">
          <img class="goBackIcon" src="@/assets/return.svg" />
          <div class="goBackText">返回</div>
        </div>
      </div>
      <!-- 页面主体 -->
      <div class="mainContent">
        <!-- 左侧导航 -->
        <div class="contentLeft">
          <div
            class="navbar"
            v-for="item in allClass1"
            :key="item"
            @click="showSubMenu(item.classID)"
          >
            <div>{{ item.className }}</div>
            <div
              class="navbarSub"
              v-for="(subItem, index) in tempSubMenu"
              :key="subItem"
              v-show="subItem.classID == item.classID"
              @click.stop="subMenuClicked(subItem.subClassID, index)"
              :class="index == dynamicClass ? 'dynamicNavbar' : ''"
            >
              <div>{{ subItem.subClassName }}</div>
            </div>
          </div>
        </div>
        <!-- 右侧列表 -->
        <div class="contentRight">
          <!-- 选中信息 -->
          <div class="message" v-if="dynamicClass != -1">
            {{ tempSubMenu[dynamicClass]?.subClassName }} ({{ totalItem }}条)
          </div>
          <!-- 列表信息 -->
          <div class="content">
            <div v-show="true">
              <div class="content_list">
                <div class="content_list_cp">事项名称</div>
                <div class="content_list_cp">事项类型</div>
                <div class="content_list_cp">面向对象</div>
              </div>
              <div
                class="content_list" :key="item"
                v-for="item in contentList"
                @click="changepage(item.BusinessID)"
              >
                <div class="content_list_cp">
                  {{ item.BusinessName }}
                </div>
                <div class="content_list_cp">
                  {{ item.ClassName }}-{{ item.SubClassName }}
                </div>
                <div class="content_list_cp">
                  {{ item.ObjectName }}
                </div>
              </div>
            </div>
          </div>
          <!-- 分页 -->
          <div class="pageCTN">
            <div class="page">
              <el-pagination
                layout="prev, pager, next"
                :total="totalItem"
                :page-size="10"
                :pager-count="5"
                :hide-on-single-page="true"
                @current-change="currentPage"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 版权信息 -->
    <div class="bottomo" :style="elementStyle">版权所有 © 2021 河南大学教务处</div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import axios from "axios";
export default {
  name: "pc_obj",
  components: {
    Breadcrumb,
  },
  watch: {
    role: function (val) {
      console.log(val);
      if (!val) {
        this.$router.push({
          path: "./pc_home",
        });
      }
      if (val == 10) {
        this.navContent = "学生事项";
      } else if (val == 11) {
        this.navContent = "教师事项";
      } else if (val == 12) {
        this.navContent = "管理人员事项";
      } else if (val == 13) {
        this.navContent = "毕业校友事项";
      }
      this.updateBreadcrumb();
    },
  },
  mounted: function () {
    console.log("进入页面");
    console.log(this.$route.params.msg);
    this.role = this.$route.params.msg;
    //获取一级目录
    // axios({
    //   methods: "get",
    //   url: "https://jwgf.henu.edu.cn:443/class/queryAllClass",
    // }).then((res) => {
    //   console.log(res.data);
    //   this.allClass1 = res.data;
    // });
    //根据对象获取一级目录
    axios({
      methods: "get",
      url:
        "https://jwgf.henu.edu.cn:443/class/queryClassAndSubcla/" + this.role,
    }).then((res) => {
      console.log(res.data);
      this.allClass1 = res.data;
    });
    this.getItem();
    this.updateElementPosition(); // 初始化设置
    window.addEventListener('resize', this.updateElementPosition); // 监听窗口大小变化
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateElementPosition); // 清理事件监听器
  },
  data() {
    return {
      //页码
      pageNum: 1,
      //分页总条数
      totalItem: 0,
      //动态增加属性
      dynamicClass: -1,
      //导航内容
      navContent: "这里是导航",
      //显示附件
      showAppend: false,
      //显示表格
      showChart: false,
      //显示保存附件表格的大盒子
      showAppendBox: true,
      //用户角色
      role: 0,
      mainflag: true,
      breadcrumbData: [],
      breadcrumbDataAll: [
        {
          key: "首页",
          path: "./pc_home",
          name: "pc_home",
          params: {},
          icon: "/home.svg",
        },
        {
          key: "学生事项",
          path: "./pc_obj",
          name: "pc_obj",
          params: { msg: 10 },
          icon: "/stu1.svg",
        },
        {
          key: "教师事项",
          path: "./pc_obj",
          name: "pc_obj",
          params: { msg: 11 },
          icon: "/tea1.svg",
        },
        {
          key: "管理人员事项",
          path: "./pc_obj",
          name: "pc_obj",
          params: { msg: 12 },
          icon: "/adm1.svg",
        },
        {
          key: "毕业校友事项",
          path: "./pc_obj",
          name: "pc_obj",
          params: { msg: 13 },
          icon: "/fre1.svg",
        },
      ],
      //下载地址
      theHref: "",
      // content: "请在此编辑您需要发布的内容",
      // editorOption: {},
      showContent: -1,
      //查询到的所有一级标题
      allClass1: [
        // {
        //   classID: "1:2",
        //   className: "你好",
        //   department: "1",
        // },
      ],
      //根据一级标题查询到的所有二级标题
      tempSubMenu: [
        {
          // subClassID: "-1",
          // classID: "3",
          // subClassName: "名称",
        },
      ],
      nav: [
        // {
        //   name: "教学运行",
        //   category: 1,
        //   submenu: [
        //     { id: 1, content: "调课" },
        //     { id: 2, content: "申请教室" },
        //   ],
        // },
      ],
      //点击二级标题后显示的列表
      contentList: [
        // {
        //   BusinessDepartment: "10",
        //   businessContent: null,
        //   BusinessClass: "1001",
        //   BusinessObject: "10",
        //   BusinessName: "关于开学军训的通知",
        //   BusinessID: 1001,
        //   ClassID: "10",
        //   ClassName: "开学教育21",
        //   Department: "15",
        //   ObjectName: "学生",
        //   SubClassName: "军训",
        // },
      ],
      //点击文章后展示的详细信息
      detailMSG: [
        {
          // ContactPhone: "10000000",
          // BusinessContent: "11月15日下午，……(还有信息，不在文档里展示了) ",
          // BusinessName: "关于开学军训的通知",
          // SubClassName: "军训",
          // BusinessClass: "1001",
          // ClassName: "开学教育",
          // BusinessDepartment: "10",
          // ClassId: "10",
          // BusinessObject: "10",
          // BusinessID: 1001,
          // DepartName: "教务处",
        },
      ],
      //类型一的附件 相关制度ID
      attachment1: [
        // {
        //   AttachmentFileName: "12",   //id
        //   AttachmentID: 1,
        //   AttachmentName: "测试数据", //展示名称
        //   AttachmentType: "1",
        //   BusinessID: "1",
        // },
      ],
      //类型二的附件  相关表格ID
      attachment2: [],
      elementStyle: {
        top:'1027px',
        bottom:'',
        left:'0',
        position: 'absolute',
        width: '100%',

        height: '21px',
        fontWeight: 400,
        fontSize: '14px',
        color: '#666666',
        lineHeight: '21px',
        textAlign: 'center',
        fontStyle: 'normal',
        textTransform: 'none',
      }
    };
  },
  methods: {
    updateElementPosition() {
      console.log(window.innerHeight);
      if (window.innerHeight > 1080) {
        this.elementStyle.bottom = '32px';
        this.elementStyle.top = ''; // 清空 top 样式
      } else {
        this.elementStyle.top = '1027px';
        this.elementStyle.bottom = ''; // 清空 bottom 样式
      }
      console.log(this.elementStyle.top);
    },
    updateBreadcrumb() {
      this.breadcrumbData[0] = {
        key: this.breadcrumbDataAll[0].key,
        name: this.breadcrumbDataAll[0].name,
        params: this.breadcrumbDataAll[0].params,
        path: this.breadcrumbDataAll[0].path,
        icon: this.breadcrumbDataAll[0].icon,
      };
      this.breadcrumbData[1] = {
        key: this.navContent,
        name:
          this.breadcrumbDataAll.find((item) => item.key === this.navContent)
            ?.name || "", // Fallback to an empty string if not found
        params:
          this.breadcrumbDataAll.find((item) => item.key === this.navContent)
            ?.params || {},
        path:
          this.breadcrumbDataAll.find((item) => item.key === this.navContent)
            ?.path || "",
        icon:
          this.breadcrumbDataAll.find((item) => item.key === this.navContent)
            ?.icon || "",
      };
    },
    //根据对象获得全部事项
    getItem: function () {
      //关闭左边二级菜单
      this.tempSubMenu = [];
      //根据对象和页面获取事项
      axios({
        methods: "get",
        url:
          "https://jwgf.henu.edu.cn:443/business/queryBusByObjId/" +
          this.role +
          "/" +
          this.pageNum,
      }).then((res) => {
        console.log(res.data);
        // this.allClass1 = res.data;
        let resTotal = res.data[res.data.length - 1];
        console.log("总数据数", resTotal.sum);
        this.totalItem = resTotal.sum;
        res.data.pop();
        console.log(res.data);
        this.contentList = res.data;
      });
    },
    //返回到主页
    returnHome: function () {
      this.$router.push("./pc_home");
    },
    chooseContent: function (index) {
      console.log("一级标题被点击", index);
      this.showContent = index + 1;
    },
    sunmenuclicked: function (index) {
      console.log("二级标题被点击", index);
      console.log(this.mainflag);
      if (!this.mainflag) {
        this.mainflag = !this.mainflag;
      }
    },
    //点击文章标题进入详情页
    changepage: function (articleID) {
      console.log("点击了文章");
      console.log("对象ID:", this.role, "文章ID", articleID);
      this.$router.replace({
        path: "./pc_detail",
        name: "pc_detail",
        params: {
          role: this.role,
          articleID: articleID,
        },
      });
      // if (this.mainflag) {
      //   this.mainflag = !this.mainflag;
      // }
      // axios({
      //   methods: "get",
      //   url:
      //     "https://jwgf.henu.edu.cn:443/seacher/queryOneBusinessWithId/" + articleID,
      // }).then((res) => {
      //   console.log(res.data);
      //   this.detailMSG = res.data;
      //   this.dealMSG(res.data);
      // });
    },
    returnPage: function () {
      console.log("返回上一级");
      this.mainflag = true;
    },
    showSubMenu(subid) {
      this.dynamicClass = -1;
      axios({
        methods: "get",
        url: "https://jwgf.henu.edu.cn:443/subclass/queryAllSubClass/" + subid,
      }).then((res) => {
        this.tempSubMenu = res.data;
        console.log(this.tempSubMenu);
      });
    },
    subMenuClicked(subClassId, index) {
      // 动态增加类
      this.dynamicClass = index;
      console.log("二级菜单点击了", subClassId);
      axios({
        methods: "get",
        url:
          "https://jwgf.henu.edu.cn:443/seacher/query/" +
          subClassId +
          "/" +
          this.role +
          "/" +
          "1",
      }).then((res) => {
        console.log(res.data);
        let resTotal = res.data[res.data.length - 1];
        console.log("总数据数", resTotal.sum);
        this.totalItem = resTotal.sum;
        res.data.pop();
        console.log(res.data);
        this.contentList = res.data;
      });
    },
    dealMSG(totalData) {
      console.log("1111111111111111");
      this.attachment1 = [];
      this.attachment2 = [];
      for (let i = 1; i < totalData.length; i++) {
        if (totalData[i].AttachmentType == 0) {
          this.attachment1.push(totalData[i]);
        } else {
          this.attachment2.push(totalData[i]);
        }
      }
      console.log(this.attachment1);
      console.log(this.attachment2);
      if (this.attachment1.length >= 1) {
        this.showAppend = true;
      } else {
        this.showAppend = false;
      }
      if (this.attachment2.length >= 1) {
        this.showChart = true;
      } else {
        this.showChart = false;
      }

      if (this.attachment1.length == 0 && this.attachment2.length == 0) {
        this.showAppendBox = false;
      } else {
        this.showAppendBox = true;
      }
    },
    download(name) {
      console.log(name);
      this.theHref = "https://jwgf.henu.edu.cn:443/attachment/download/" + name;
      axios({
        method: "post",
        url: "https://jwgf.henu.edu.cn:443/attachment/download/" + name,
        responseType: "blob",
      }).then((res) => {
        console.log(res.data);
        // this.contentList = res.data;
        this.toDownload(res.data);
      });
    },
    toDownload(data) {
      if (!data) {
        return;
      }

      if (confirm("是否下载此附件")) {
        let url = window.URL.createObjectURL(new Blob([data]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", this.theHref);
        document.body.appendChild(link);
        link.click();
      }
    },
    //获取文件
    getFile: function (articleID) {
      console.log("点击了文章");
      if (this.mainflag) {
        this.mainflag = !this.mainflag;
      }
      axios({
        methods: "get",
        url:
          "https://jwgf.henu.edu.cn:443/seacher/queryOneBusinessWithId/" +
          articleID,
      }).then((res) => {
        console.log(res.data);
        this.detailMSG = res.data;
        this.dealMSG(res.data);
      });
    },
    //分页相关
    currentPage(index) {
      console.log(index);
      this.pageNum = index;
      axios({
        methods: "get",
        url:
          "https://jwgf.henu.edu.cn:443/business/queryBusByObjId/" +
          this.role +
          "/" +
          this.pageNum,
      }).then((res) => {
        console.log(res.data);

        let resTotal = res.data[res.data.length - 1];
        console.log("总数据数", resTotal.sum);
        this.totalItem = resTotal.sum;
        res.data.pop();
        console.log(res.data);
        this.contentList = res.data;
      });
    },
  },
};
</script>

<style>
.pc_obj {
  width: 100%;
  min-height: 100%;
  background: #f6f9ff;
  /* position: relative; */
}
.bgo {
  position: absolute;
  width: 100%;
  height: auto;
  top: 0; /* 垂直居中 */
  left: 0; /* 水平居中 */
}
.bgo img {
  width: 100%;
  height: auto;
}
.titleo {
  position: absolute;
  left: 20%;
  top: 35px;
  width: 489px;
  height: 50px;
}
.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  left: 20%;
  top: 120px;
  width: 60%;
  height: 72px;
  background: #f6f9ff;
  border-radius: 8px 8px 8px 8px;
}

.breadcrumb {
  margin-left: 2%;
}

.goBack {
  margin-right: 2%;
  display: flex;
  align-items: center;
}

.goBack div {
  width: 32px;
  height: 48px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #00589f;
  line-height: 48px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.goBack img {
  margin-right: 4px;
}

.goBack:hover {
  cursor: pointer;
}
.mainContent {
  position: absolute;
  display: flex;
  justify-content: space-between;
  left: 20%;
  top: 200px;
  height: 75%;
  width: 60%;
  
}
.contentLeft {
  height: 100%;
  width: 20%;
  background: #ffffff;
  border-radius: 8px 0px 0px 8px;
  padding: 24px 15px;

  overflow-y: auto; /* 启用垂直滚动条 */
}
/* Optional: 自定义滚动条样式 */
.articled::-webkit-scrollbar {
  width: 3px;
}
.articled::-webkit-scrollbar-thumb {
  background-color: #00589f; /* 滚动条的颜色 */
  border-radius: 10px;
}
.pc_obj .navbar {
  position: relative;
  border-radius: 4px 4px 4px 4px;
}
.pc_obj .navbar > div {
  margin-left: 15px; /* 从左侧开始缩进20% */
  font-weight: 200;
  text-align: left;
  font-size: 18px;
  color: #333333;
  line-height: 48px;
  font-style: normal;
  text-transform: none;
}
.pc_obj .navbar::after {
  content: "";
  position: absolute;
  bottom: 0; /* 伪元素位于navbar底部 */
  left: 72px; /* 从左侧开始缩进20% */
  right: 50px; /* 从右侧缩进20% */
  height: 1px; /* 边界线高度 */
  background-color: #f3f8fd; /* 边界线颜色 */
}
.pc_obj .navbarSub {
  text-align: left;
  border-radius: 4px 4px 4px 4px;
  position: relative;
}

.pc_obj  .navbarSub > div {
  margin-left: 10px;
  font-weight: 200;
  text-align: left;
  font-size: 17px;
  color: #333333;
  line-height: 48px;
  font-style: normal;
  text-transform: none;
  position: relative;
}
.pc_obj .navbarSub::after {
  content: "";
  position: absolute;
  bottom: 0; /* 伪元素位于navbar底部 */
  left: 4px; /* 从左侧开始缩进20% */
  right: 4px; /* 从右侧缩进20% */
  height: 1px; /* 边界线高度 */
  background-color: #f3f8fd; /* 边界线颜色 */
}
.dynamicNavbar > div {
  color: #ffffff;
}
.pc_obj .dynamicNavbar {
  background: #00589f;
}
.contentRight {
  height: 100%;
  flex: 1;
  margin-left: 20px;
  padding: 20px 32px;
  background: #ffffff;
  border-radius: 0px 8px 8px 0px;
  text-align: left;
  position: relative;
}
.message {
  font-weight: 300;
  font-size: 20px;
  color: #00589f;
  line-height: 27px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.content {
  width: 100%;
  padding-right: 30px;
  height: auto;
  border: none;
  position: relative;
}
.content_list {
  height: 48px;
  text-align: left;
  padding: 0 30px;
  border: none;
  display: flex;
  align-items: center;
  color: #333333;
  border-radius: 8px 8px 8px 8px;
}
.content_list:nth-child(odd) {
  background: #F3F8FD;
}
.content_list:hover {
  cursor: pointer;
}
.content_list .content_list_cp:nth-child(1),
.content_list .content_list_cp:nth-child(2) {
  flex: 4;
}
.content_list .content_list_cp:nth-child(3) {
  flex: 1;
  text-align: center;
}
.pageCTN {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  justify-content: center;
}
::v-deep .el-pager li {
  width: 44px;
  height: 42px;
  font-weight: 400;
}
::v-deep .el-pager li.active {
  background-color: #f3f8fd; /* 设置选中页的背景颜色 */
  color: #00589f; /* 设置选中页的文字颜色 */
}

.bottomo {
  position: absolute;
  margin-top: 10px;
  left: ;
  width: 209px;
  height: 21px;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 21px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.el-pagination {
  display: flex;
  flex-direction: row;
}
.el-pager {
  display: flex;
  justify-content: center;  /* 水平居中内容 */
  align-items: center;      /* 垂直居中内容 */
}
.page .el-pager li{
  padding: 8px 4px !important;
  display: inline-block !important; /* 防止li占满整行 */
  text-align: center !important;  /* 水平居中文字 */
  font-size: 16px !important;
  white-space: nowrap !important;  /* 防止文字换行 */
}
</style>